import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Input,
  Stack,
  useBoolean,
  useDisclosure,
} from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters/base-filter-button';
import { usePageParams } from 'hooks/use-page-params';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type TInputs = {
  licenseNumber: string;
};

const defaultValues: TInputs = {
  licenseNumber: '',
};

export const LicenseNumberFilterButton = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  // Update active filter button
  useEffect(() => {
    if (params.licenseNumber) setIsActive.on();
    else setIsActive.off();
  }, [params.licenseNumber, setIsActive]);

  const { handleSubmit, formState, reset, setValue, register } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update values when params change
  useEffect(() => {
    setValue('licenseNumber', params.licenseNumber ? String(params.licenseNumber) : '');
  }, [params.licenseNumber, setValue]);

  const onSubmit = (data: TInputs) => {
    if (data.licenseNumber && data.licenseNumber.trim()) {
      params.licenseNumber = data.licenseNumber.trim();
    } else {
      delete params.licenseNumber;
    }

    setPageParams(params);
    onClose();
    reset(data);
  };

  const handleClose = () => {
    onClose();
    setValue('licenseNumber', params.licenseNumber ? String(params.licenseNumber) : '');
  };

  const handleDisableFilterButton = () => {
    return Object.keys(formState.dirtyFields).length === 0;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack as='form' spacing='lg' p='md' pt='lg' onSubmit={handleSubmit(onSubmit)}>
          <FormControl>
            <FormLabel>License Number</FormLabel>
            <Input {...register('licenseNumber')} placeholder='Enter license number (e.g., CN-1234567)' />
          </FormControl>

          <HStack justify='flex-end'>
            <Button variant='outline' colorScheme='red' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='red' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </HStack>
        </Stack>
      }
    />
  );
};
